// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiHenther: "https://api.henther.no/henther/v1",
  encryptSecretKey: "Henther",
  apiUrl: "https://europe-west1-frigg-kantine.cloudfunctions.net",
  appUrl: "https://app.friggkantine.no",
  // Jofemar vending-machine license renewal dashboard (separate Next.js app,
  // deployed on Lightsail behind Caddy — see deploy/LIGHTSAIL.md in that repo).
  // Points at the local dev server until it's actually deployed.
  jofemarUrl: "http://localhost:3001",
  // Survey Forms admin (separate Next.js app) — opened from the sidebar with SSO.
  surveyFormsUrl: "http://localhost:3000",
  baseUrl: 'https://api.henther.no/stocking/v1',
  // baseUrl: 'http://localhost:9000',
  baseUrlAPI: 'https://api.henther.no/api',

  apiKey: 'friggkantine-stocking-service-api-key-2241',
  firebaseConfig: {
    apiKey: "AIzaSyA7aKWOp-LQNkE6PZ8KNL1CNvSifkPYZEI",
    authDomain: "frigg-kantine.firebaseapp.com",
    projectId: "frigg-kantine",
    databaseURL: 'https://frigg-kantine.firebaseio.com',
    storageBucket: "frigg-kantine.appspot.com",
    messagingSenderId: "308881591789",
    appId: "1:308881591789:web:ca4f20ef745f8d05636be4",
    measurementId: "G-GZPTHWTBBZ"
  }



  // apiUrl : "https://europe-west1-electron-beta-test.cloudfunctions.net",
  // firebaseConfig : {
  //   "apiKey": "AIzaSyB-TmHGbtvyaX7LTwDC2YU3OekAiIcqd14",
  //   "authDomain": "electron-beta-test.firebaseapp.com",
  //   "databaseURL": "https://electron-beta-test.firebaseio.com",
  //   "projectId": "electron-beta-test",
  //   "storageBucket": "electron-beta-test.appspot.com",
  //   "messagingSenderId": "578139832097",
  //   "appId": "1:578139832097:web:dcbdcdb757313978"
  // }
}



// export const environment = {
//   production: false,
//   apiHenther: "https://api.henther.no/henther/v1",
//   encryptSecretKey: "Henther",
//   apiUrl: "https://europe-west1-app-henther.cloudfunctions.net",
//   appUrl: "https://app.henther.no",
//   firebaseConfig: {
//     apiKey: "AIzaSyDEfym2Gqbe2GRLxXxA2k2qNtSCtWrFWqs",
//     authDomain: "app-henther.firebaseapp.com",
//     projectId: "app-henther",
//     storageBucket: "app-henther.appspot.com",
//     messagingSenderId: "984499963581",
//     appId: "1:984499963581:web:a06c55b0d20aad890319d4",
//     measurementId: "G-EH6HH64JMK"
//   }
// }


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
